import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TextField, Autocomplete } from "@mui/material";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { handleAddNewCalendar } from "./CalendarsUtils/handleAddNewCalendar";
import { useCalendarGroupAutocomplete } from "./CalendarsUtils/useCalendarGroupAutocomplete";
import { NavigateFunction } from "react-router-dom";

export const AddCalendarDialog = ({
  addCalendarDialogOpen,
  setAddCalendarDialogOpen,
  setFetchingCalendarData,
  calendarData,
  setCalendarData,
  setCalendarAlerts,
  calendarsSearchString,
  navigate,
}: {
  addCalendarDialogOpen: boolean;
  setAddCalendarDialogOpen: Dispatcher<boolean>;
  setFetchingCalendarData: Dispatcher<boolean>;
  calendarData: any;
  setCalendarData: any;
  setCalendarAlerts: any;
  calendarsSearchString: any;
  navigate: NavigateFunction;
}) => {
  const parentAccounts = JSON.parse(
    localStorage?.parentAccounts || "[]"
  );

  const parentNames = new Map();
  parentAccounts.forEach((object: any) => {
    parentNames.set(object.id, object.name);
  });

  const [newCalendarInfo, setNewCalendarInfo] = React.useState<any>({
    group: "",
    name: "",
  });

  const {
    filteredGroupOptions,
    groupFilterInput,
    onGroupInputChange,
    clearGroupFilterInput,
    filterOptionsIdentity,
  } = useCalendarGroupAutocomplete(parentAccounts, newCalendarInfo.group);

  const prevDialogOpenRef = React.useRef(false);
  React.useEffect(() => {
    if (addCalendarDialogOpen && !prevDialogOpenRef.current) {
      clearGroupFilterInput();
    }
    prevDialogOpenRef.current = addCalendarDialogOpen;
  }, [addCalendarDialogOpen, clearGroupFilterInput]);

  return (
    <Dialog open={addCalendarDialogOpen}>
      <DialogTitle id="add-calendar">Add Calendar</DialogTitle>
      <DialogContent sx={{ width: 450, height: 375 }}>
        <Autocomplete
          disablePortal
          options={filteredGroupOptions}
          inputValue={groupFilterInput}
          onInputChange={onGroupInputChange}
          filterOptions={filterOptionsIdentity}
          getOptionLabel={(option) => option.name || ""}
          isOptionEqualToValue={(option, value) =>
            value != null && String(option.id) === String(value.id)
          }
          value={
            newCalendarInfo.group !== "" && newCalendarInfo.group != null
              ? {
                id: Number(newCalendarInfo.group),
                name: parentNames.get(Number(newCalendarInfo.group)),
                index: parentAccounts.findIndex(
                  (obj: any) => obj.id === Number(newCalendarInfo.group)
                ),
              }
              : null
          }
          onChange={(event: any, value: any) => {
            if (value == null) {
              clearGroupFilterInput();
            }
            setNewCalendarInfo((previousState: any) => ({
              ...previousState,
              group: value?.id ?? "",
            }));
          }}
          sx={{ width: 350 }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="Group"
              autoComplete="off"
              id="group_name"
              name="group_name"
            />
          )}
        />
        <br></br>
        <br></br>
        <TextField
          id="sureview_subject"
          variant="standard"
          label="Calendar Name"
          value={newCalendarInfo.name}
          onChange={(event) => {
            setNewCalendarInfo((previousState: any) => {
              return { ...previousState, name: event.target.value };
            });
          }}
          sx={{ width: "350px" }}
          helperText=""
          type="string"
        />     
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setAddCalendarDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setFetchingCalendarData(true);
            setAddCalendarDialogOpen(false);
            handleAddNewCalendar(
              newCalendarInfo,
              setFetchingCalendarData,
              calendarData,
              setCalendarData,
              setCalendarAlerts,
              calendarsSearchString,
              navigate
            );
          }}
          text="Submit"
          disabled={!newCalendarInfo.group || !newCalendarInfo.name}
        />
      </DialogActions>
    </Dialog>
  );
};
